// extracted by mini-css-extract-plugin
module.exports = {"continueButton":"ReviewPage_continueButton__30Oqb","containerHost":"ReviewPage_containerHost__2EDXM"};